import type { ComponentProps } from 'react'
import { cn } from '@/lib/utils'

/* Bidi — for text of unknown script: a staff member's name, a free-text note,
   a guest request typed by whoever typed it.

   Renders <bdi>, the element the HTML specification provides for precisely
   this. Two things happen and both are needed:

     isolation      the run cannot disturb, or be disturbed by, the text around
                    it. Without it "Noor H." inside an Arabic card renders as
                    ".Noor H" — the trailing full stop is a neutral character
                    and the bidi algorithm attaches it to the paragraph's
                    right-to-left side.
     dir="auto"     direction is taken from the first strong character of the
                    content, so an Arabic name reads right-to-left and a Latin
                    name left-to-right, in the same component, with no branch
                    in the calling code.

   `unicode-bidi: isolate` on a <span> is NOT sufficient. It isolates the run
   from its surroundings but still lays the content out in the inherited
   direction, so the misplaced full stop survives. This was verified in the
   Arabic render, not assumed.

   Use Identifier, not this, for room numbers and references — those are always
   left-to-right and always Western digits. Use this for human-entered text. */

export function Bidi({ className, ...props }: ComponentProps<'bdi'>) {
  return <bdi dir="auto" className={cn(className)} {...props} />
}
